import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule, MatButtonToggleModule, MatCardModule, MatDialogModule, MatExpansionModule, MatIconModule, MatProgressSpinnerModule, MatSliderModule, MatSlideToggleModule, MatTable, MatTableDataSource, MatTableModule } from "@angular/material";
import { TooltipModule } from "../../../../tooltip/tooltip.module";
import { CommonSectionsModule } from "../../../common/common-sections.module";
import { FlexDashboardComponent } from "./flex-dashboard/flex-dashboard.component";
import { FlexHomeComponent } from "./flex-home.component";
import { FlexHomeRoutingModule } from "./flex-home.routing.module";
import { FlexMenuComponent } from "./flex-menu/flex-menu.component";
import { QuickSetupComponent } from "./quick-setup/quick-setup.component";
import { ExpandedProductsComponent } from "./expanded-products/expanded-products.component";
import { IndianCurrencyFormatterModule } from "../../../../views/common/indian-currency-formatter/indian-currency-formatter.module";
import { MatCheckboxModule } from "@angular/material";
import { FinzyBoltPopupComponent } from "../finzy-bolt-popup/finzy-bolt-popup.component";
import { UserAttributeComponent } from "../user-attribute/user-attribute.component";
import { MaxNCashAttributeComponent } from "../max-n-cash-attribute/max-n-cash-attribute.component";
import { CustomNCashAttributeComponent } from "../custom-n-cash-attribute/custom-n-cash-attribute.component";
import { InterestOnlyNCashAttributeComponent } from "../interest-only-n-cash-attribute/interest-only-n-cash-attribute.component";
import { SwiftAttributeComponent } from "../swift-attribute/swift-attribute.component";
import { ProductResolver } from "../../../../resolvers/product.resolver";
import { UserAttributeResolver } from "../user-attribute/user-attribute.resolver";
import { ConfirmPopUpFinzyFlexModule } from "../confirm-pop-up-finzy-flex/confirm-pop-up-finzy-flex.module";
import { SharedPreferenceDataService } from "../../../../service/shared-preference-data.service";
import { InvestmentService } from "../../../../service/finzy-flex/investment/investment.service";
import { FinzyFlexGuard } from "../../../../guards/finzy-flex.guard";
import { EnableSwiftPreferencePopUpComponent } from "../enable-swift-preference-pop-up/enable-swift-preference-pop-up.component";
import { LenderAccountInfoResolver } from "../../../../resolvers/lender-account-info.resolver";
import { AccountService } from "../../../../service/finzy-flex/account/account.service";
import { UserAttributeDeactivationGuard } from "../user-attribute/user-attribute-deactivation-guard";
import { ConfirmationPopupWithSvgModule } from "../confirmation-popup-with-svg/confirmation-popup-with-svg.module";
import { NCashDataUtil } from "../../../../utils/finzy-flex/nCash-data.util";
import { InvestmentOptionsComponent } from "./flex-dashboard/investment-options/investment-options.component";
import { FlexInterestCertificateComponent } from "./flex-interest-certificate/flex-interest-certificate.component";
import { HorizontalLoaderModule } from "../../../../horizontal-loader/horizontal-loader.module";
import { LoaderModule } from "../../../../../app/directives/loader.module";
import { ExpandedProductCategoryComponent } from "./expanded-products/expanded-product-category/expanded-product-category.component";

@NgModule({
    declarations: [
        FlexHomeComponent,
        FlexMenuComponent,
        FlexDashboardComponent,
        FlexInterestCertificateComponent,
        QuickSetupComponent,
        ExpandedProductsComponent,
        UserAttributeComponent,
        MaxNCashAttributeComponent,
        CustomNCashAttributeComponent,
        InterestOnlyNCashAttributeComponent,
        SwiftAttributeComponent,
        FinzyBoltPopupComponent,
        EnableSwiftPreferencePopUpComponent,
        FlexHomeComponent,
        InvestmentOptionsComponent,
        ExpandedProductCategoryComponent
    ],
    imports: [
        TooltipModule,
        FlexHomeRoutingModule,
        CommonSectionsModule,
        IndianCurrencyFormatterModule,
        MatCheckboxModule,
        FormsModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatSliderModule,
        ReactiveFormsModule,
        ConfirmPopUpFinzyFlexModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatButtonModule,
        MatTableModule,
        ConfirmationPopupWithSvgModule,
        HorizontalLoaderModule, 
	    LoaderModule,
        MatButtonToggleModule,
        MatIconModule
    ],
    providers: [
        UserAttributeResolver,
        ProductResolver,
        SharedPreferenceDataService,
        InvestmentService,
        FinzyFlexGuard,
        LenderAccountInfoResolver,
        AccountService,
        UserAttributeDeactivationGuard,
        NCashDataUtil,
    ],
    exports: [SwiftAttributeComponent]
})
export class FlexHomeModule { }